var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Breadcrumb',{style:({margin: '24px 0'})},[_c('BreadcrumbItem',[_vm._v("首页")]),_c('BreadcrumbItem',[_vm._v("内容管理")]),_c('BreadcrumbItem',[_vm._v("新闻列表")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }